package tta.destinigo.talktoastro.feature_expert_search.di

import org.koin.dsl.module
import tta.destinigo.talktoastro.feature_expert_search.data.api.SearchExpertApi

val searchExpertCommonModule  = module {
    single { SearchExpertApi() }
}